import React from "react";
import PinBtn from "./PinBtn.js";
import TextField from "./TextField.js";

const Form = (props) => {
    return (
        <form className='m-0 text-center' onSubmit={props.onSubmit}>
            <h4 className='mb-4 text-xl'>Enter Pin</h4>
            {/* <input type='hidden' name='password' value={inputVal} /> */}
            <TextField inputLength={props.inputVal.length} clickHandler={props.onClearLastDigit} />
            <div className='row flex'>
                <PinBtn btnVal='1' clickHandler={props.addNum} />
                <PinBtn btnVal='2' clickHandler={props.addNum} />
                <PinBtn btnVal='3' clickHandler={props.addNum} />
            </div>
            <div className='row flex'>
                <PinBtn btnVal='4' clickHandler={props.addNum} />
                <PinBtn btnVal='5' clickHandler={props.addNum} />
                <PinBtn btnVal='6' clickHandler={props.addNum} />
            </div>
            <div className='row flex'>
                <PinBtn btnVal='7' clickHandler={props.addNum} />
                <PinBtn btnVal='8' clickHandler={props.addNum} />
                <PinBtn btnVal='9' clickHandler={props.addNum} />
            </div>
            <div className='row flex'>
                <PinBtn type='btn' clickHandler={props.onClearField} btnVal='Clear' />
                <PinBtn btnVal='0' clickHandler={props.addNum} />
                <PinBtn type='btn' btnVal='Login' />
            </div>
        </form>
    );
};

export default Form;
